import { createStyles } from 'utils/createStyle';
import { colors } from 'styles/settings';

export const ProductDetailScreenStyles = createStyles({
    brandLogoOffer: [
        'bg-grey-1 text-center text-white rounded-t-md text-xs lg:text-base',
        {
            height: '2.5rem',
            lineHeight: '2.5rem',
        },
    ],
    brandLogoOfferMobile: [
        'bg-grey-1 text-center text-white rounded-t-md text-xs lg:text-base',
        {
            height: '1.25rem',
            lineHeight: '1.25rem',
        },
    ],
    body: [
        'px-6 xd:px-16 xl:px-44 my-8 lg:my-10 gap-8 xl:gap-20 block text-sm lg:text-base',
        {
            gridTemplateColumns: 'minmax(180px, 200px) 1fr',
        },
    ],
    tabs: [
        'flex flex-col w-full',
        {
            maxWidth: '780px',
        },
    ],
    tabList: ['flex flex-shrink-0 border-b border-gray-50'],
    logoSection: ['relative'],
    logoContainer: [
        'inline-block lg:transform lg:-translate-x-48 xl:-translate-x-64',
        {
            width: '100%',
        },
    ],
    logoImage: [
        'relative w-full',
        {
            paddingTop: '100%',
            borderColor: colors.grey3,
        },
    ],
    firstRow: ['max-w-3xl w-full flex pb-4'],
    title: [
        'text-brand-dark lg:mt-2 text-3xl lg:text-5xl max-h-28 pb-2',
        {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
        },
    ],
    main: [
        'mt-4 lg:mt-8 max-w-3xl mx-auto',
        {
            maxWidth: '780px',
        },
    ],
    termsSkeleton: ['w-full mt-4', { height: '11rem', minWidth: '100%' }],
    productDetail: ['mt-8 w-full', { height: '19rem', minWidth: '100%' }],
    optionalLoggedInDescription: ['mt-1 w-full text-grey-1 relative', { fontSize: '0.875rem' }],
    readMoreButton: [
        'text-brand pl-4 font-semibold',
        {
            position: 'absolute',
            right: 0,
            bottom: '1px',
            height: '1rem',
            lineHeight: '10px',
            marginBottom: '0px',
            paddingBottom: '4px',
            background:
                'linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 10%, rgba(255, 255, 255, 1) 100%)',
            '@media(min-width: 1024px)': {
                display: 'none',
            },
        },
    ],
    readMoreCollapsed: [
        {
            maxHeight: '3.75rem',
            '@media(min-width: 1024px)': {
                maxHeight: 'none',
            },
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    ],
    readMoreExpanded: [{ maxHeight: 'none' }],
});
